module.exports = __webpack_public_path__ + "static/media/david1.34fa52ae.jpg";